import Chip from '@mui/material/Chip';
import ListItemButton from '@mui/material/ListItemButton';
import Typography from '@mui/material/Typography';
import type { RecentlyViewedDoc } from '../../hooks/use-recently-viewed-docs';
import { PageKindIcon } from '../page-kind-icon';

interface RecentlyViewedRowProps {
  entry: RecentlyViewedDoc;
  onSelectPage: (spaceId: number, pageSlug: string) => void;
}

export function RecentlyViewedRow({
  entry,
  onSelectPage,
}: RecentlyViewedRowProps) {
  return (
    <ListItemButton
      onClick={() => onSelectPage(entry.spaceId, entry.pageSlug)}
      sx={{ px: 2, py: 1.25, gap: 1.5 }}
    >
      <PageKindIcon entityType={entry.entityType} withTooltip />
      <Typography
        variant="body2"
        noWrap
        sx={{ flex: 1, minWidth: 0, color: 'text.primary' }}
      >
        {entry.title}
      </Typography>
      <Chip
        label={entry.spaceName}
        variant="outlined"
        size="small"
        sx={{
          flexShrink: 0,
          height: 24,
          fontSize: 12,
          color: 'text.secondary',
        }}
      />
    </ListItemButton>
  );
}
